<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="accountSet.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="accountSet"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="账套编号" prop="accountSetNo">
          <el-input v-if="accountSet.pkid > 0" v-model="accountSet.accountSetNo" disabled placeholder="请输入"/>
          <el-input v-else v-model="accountSet.accountSetNo" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="账套名称" prop="accountSetName">
          <el-input v-model="accountSet.accountSetName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="类型" prop="configType">
          <el-select v-model="accountSet.configType" clearable placeholder="请选择">
            <el-option
                v-for="item in configTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="地址" prop="configValue">
          <el-input v-model="accountSet.configValue" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  export default {
    components: {},
    data() {
      return {
        constant,
        configTypes: constant.toSelect(constant.configTypes),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        accountSet: {
          pkid: 0,
          accountSetNo: "",
          accountSetName: "",
          configType: 10,
          configValue: "",
        },
        ruleValidate: {
          accountSetNo: {required: true, message: "账套编号不能为空",trigger: "blur"},
          accountSetName: {required: true, message: "账套名称不能为空",trigger: "blur"},
          configType: {required: true, message: "类型不能为空",trigger: "blur"},
          configValue: {required: true, message: "地址不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.accountSet.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `accountSetConfigs/${this.accountSet.pkid}`)
          .then(resp => {
            console.log(resp);
            this.accountSet = resp;
          });
      },
      handleSubmit() {
        if(this.accountSet.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "accountSetConfigs", this.accountSet)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "accountSetConfigs", this.accountSet)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tabInput{
    input{
      text-align: center!important;
    }
  }
</style>
